import { render, staticRenderFns } from "./AirDataBoard.vue?vue&type=template&id=5714f67a&scoped=true&"
import script from "./AirDataBoard.vue?vue&type=script&lang=js&"
export * from "./AirDataBoard.vue?vue&type=script&lang=js&"
import style0 from "./AirDataBoard.vue?vue&type=style&index=0&id=5714f67a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5714f67a",
  null
  
)

export default component.exports